import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
// ⚠️ Deep import of the .desktop variant is REQUIRED (ledger hazard 6): a bare folder import
// typechecks against index.native, whose LoginSlice exports a different surface.
import { supportLogout, userLogout } from "../LoginSlice";
import {
  sharedInitialState,
  sharedReducers,
  type SharedGlobalState,
} from "./shared";

export type {
  NormalizedRelease,
  NormalizedReleaseItem,
  ReleaseNotesState,
} from "../../../types/releaseData";

export interface GlobalState extends SharedGlobalState {
  showKeyboardShortcuts: boolean;
  isUpdateDownloaded: string;
  isUpdateCompleted: boolean;
}

const initialState: GlobalState = {
  ...sharedInitialState,
  // Web starts DISCONNECTED; mobile starts `true`. Differing default, preserved (hazard 7).
  isMasterConnected: false,
  showKeyboardShortcuts: false,
  isUpdateDownloaded: "",
  isUpdateCompleted: false,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    ...sharedReducers,
    toggleKeyboardShortcutsModal: (
      state: GlobalState,
      action: PayloadAction<any>
    ) => {
      state.showKeyboardShortcuts = action.payload.show;
    },
    updateGlobalSlice: (state: GlobalState, action: PayloadAction<any>) => {
      return action.payload;
    },
    isDownloadCompleted: (state: GlobalState, action: PayloadAction<any>) => {
      state.isUpdateDownloaded = action.payload;
    },
    updateComplete: (state: GlobalState, action: PayloadAction<any>) => {
      state.isUpdateCompleted = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {
        state.isOfflineLogin = false;
      })
      // ⚠️ EMPTY ON PURPOSE — verbatim from apps/web. The case IS registered but does nothing.
      .addCase(supportLogout, () => {});
  },
});

export const {
  setLoader,
  orderLevelError,
  openCustomModel,
  alertModalActive,
  updateNotificationValue,
  toggleOfflineOnlineMode,
  updateOfflineLogin,
  updateMasterConnectedStatus,
  setReleaseNotes,
  getReleaseNotesData,
  releaseNotesCallComplete,
  toggleKeyboardShortcutsModal,
  updateGlobalSlice,
  isDownloadCompleted,
  updateComplete,
} = globalSlice.actions;
export default globalSlice.reducer;
